import { ATTENDANCE_SUBVIEW_MODEL } from '../Model/Model';
import ShiftAccess from './ShiftAccess/ShiftAccess';
import React from 'react';
import Settings from './Settings/Settings';
import Department from './Department/Department';
import Geofence from './Geofence/Geofence';

/**
 *
 * @Author: Cecilia López Martínez
 * @JobTitle : Full Stack Developer - IBL
 * @Email : clopez@ibl.mx
 *
 */
const ManageTab = (props) => {

    const {
        registerAction,
        subView,
        changeSubViewManage,

        option,
        selectForDelete,
        setSelectForDelete,
        setBodyForExport,
        searchElement,
        setSearchElement,
        setSimpleSearch,
        search,
        setSearch,
    } = props;

    return (
        <>
            {subView === ATTENDANCE_SUBVIEW_MODEL.MANAGE.SHIFT_ACCESS &&
                <ShiftAccess
                    subView={subView}
                    changeSubViewManage={changeSubViewManage}

                    option={option}
                    selectForDelete={selectForDelete}
                    setSelectForDelete={setSelectForDelete}
                    setBodyForExport={setBodyForExport}
                    searchElement={searchElement}
                    setSearchElement={setSearchElement}
                    setSimpleSearch={setSimpleSearch}
                    search={search}
                    setSearch={setSearch}
                    registerAction={registerAction}
                />
            }

            {subView === ATTENDANCE_SUBVIEW_MODEL.MANAGE.SETTINGS &&
                <>
                    <Settings
                        subView={subView}
                        changeSubViewManage={changeSubViewManage}
                        registerAction={registerAction}
                    />
                </>
            }

            {subView === ATTENDANCE_SUBVIEW_MODEL.MANAGE.DEPARTMENT_POLICIES &&
                <>
                    <Department
                        subView={subView}
                        changeSubViewManage={changeSubViewManage}
                        registerAction={registerAction}
                    />
                </>
            }

            {subView === ATTENDANCE_SUBVIEW_MODEL.MANAGE.GEOFENCE &&
                <>
                    <Geofence
                        subView={subView}
                        changeSubViewManage={changeSubViewManage}
                        registerAction={registerAction}
                        option={option}
                        searchElement={searchElement}
                        setSimpleSearch={setSimpleSearch}
                        selectForDelete={selectForDelete}
                        setSearchElement={setSearchElement}
                        setSelectForDelete={setSelectForDelete}
                    />
                </>
            }

        </>
    );

}

export default ManageTab
